import React from 'react';

const Switcher = ({ checkId, isChecked, onCheckboxClick }) => {
  const localClass = {
    margin: 0,
  };

  const handleCheckboxChange = (e) => {
    onCheckboxClick(e.target.checked);
  };

  return (
    <div data-bem="Switcher">
      <input type="checkbox" className="checkbox-switch" id={checkId} checked={isChecked} onChange={handleCheckboxChange} />
      <label style={localClass} htmlFor={checkId} />
    </div>
  );
};

export default Switcher;
